import { BaseURL } from '../../config/axios';

export default function UploadAudio({ setData, label, name, audio, }) {

    const handleDelete = (event) => {
        const { checked } = event.target
        if (checked) {
            setData(prev => {
                return {
                    ...prev,
                    [name]: null
                }
            })
        }
        else
            setData(prev => {
                const { [name]: O, ...previe } = prev
                return {
                    ...previe,
                }
            })
    }

    const handleFileChange = (e) => {
        const { files } = e.target
        if (files[0])
            setData(prev => {
                return {
                    ...prev,
                    [name]: files[0]
                }
            })
        else
            setData(prev => {
                const { [name]: O, ...previe } = prev
                return {
                    ...previe,
                }
            })
    }

    return (
        <div className='flex flex-col items-start'>
            <label className={`mr-3 mb-3 text-sm`}>{label}</label>
            <div
                className={`flex flex-col w-full items-end p-4 border-2 border-dashed border-gray-300 rounded-lg cursor-pointer`}>
                <input
                    dir='ltr'
                    type="file"
                    className='w-fit'
                    onChange={handleFileChange}
                    id={name} accept='audio/*'
                />
                {(!!audio && audio.file_path) &&
                    <div className='flex flex-wrap items-center justify-between w-full gap-3'>
                        <div className="flex items-center gap-1">
                            <input onChange={handleDelete} type="checkbox" name={name} id={name + 1} />
                            <label className='select-none' htmlFor={name + 1}>حذف صوت قبلی</label>
                        </div>
                        <div className="relative mt-4">
                            <audio
                                src={BaseURL + audio?.file_path}
                                controls
                            />
                        </div>
                    </div>
                }
            </div>
        </div>
    );
}
